// import React, { useState, useEffect } from "react";
// import privateApi from "../../apis/privateApi";
// import Notification from "../../components/Notification/Notification";
// import Spinner from "../../components/Spinner/Spinner";
// import * as XLSX from "xlsx";
// import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
// import "./ProgrammeSegment.css";
// import { Link } from "react-router-dom";

// /* =====================================================
//    Recursive Row Component
// ===================================================== */
// const ProgrammeRow = ({ node, level = 1, setNotification, openConfirm }) => {
//     const [expanded, setExpanded] = useState(false);
//     const [editing, setEditing] = useState(false);
//     const [description, setDescription] = useState(node.description || "");
//     const [content, setContent] = useState(node.content || "");
//     const [remark, setRemark] = useState(node.remark || "");

//     const hasChildren = node.children && node.children.length > 0;

//     const generateToken = () =>
//         Math.random().toString(36).substring(2, 8).toUpperCase();

//     const handleSaveClick = () => {
//         if (description.length > 100 || remark.length > 100) {
//             setNotification({
//                 show: true,
//                 message: "Description and Remark must not exceed 100 characters",
//                 type: "error",
//             });
//             return;
//         }

//         const token = generateToken();
//         openConfirm({
//             open: true,
//             token,
//             nodeId: node._id,
//             payload: { description, content, remark },
//         });
//     };

//     return (
//         <>
//             <tr className={`programme-row level-${level}`}>
//                 <td>
//                     <div
//                         className="tree-cell"
//                         style={{ paddingLeft: `${level * 20}px` }}
//                         onClick={() => hasChildren && setExpanded(!expanded)}
//                     >
//                         {hasChildren && <span className="toggle">{expanded ? "▼" : "▶"}</span>}
//                         {node.code}
//                     </div>
//                 </td>

//                 <td>
//                     {editing ? (
//                         <input value={description} onChange={(e) => setDescription(e.target.value)} />
//                     ) : (
//                         node.description || "-"
//                     )}
//                 </td>

//                 <td>
//                     {editing ? (
//                         <input value={content} onChange={(e) => setContent(e.target.value)} />
//                     ) : (
//                         node.content || "-"
//                     )}
//                 </td>

//                 <td>
//                     {editing ? (
//                         <input value={remark} onChange={(e) => setRemark(e.target.value)} />
//                     ) : (
//                         node.remark || "-"
//                     )}
//                 </td>

//                 <td>
//                     <span className={node.isActive ? "status-active" : "status-inactive"}>
//                         {node.isActive ? "Active" : "Inactive"}
//                     </span>
//                 </td>

//                 <td>
//                     {!editing ? (
//                         <button onClick={() => setEditing(true)}>✏️</button>
//                     ) : (
//                         <>
//                             <button onClick={handleSaveClick}>💾</button>
//                             <button onClick={() => setEditing(false)}>❌</button>
//                         </>
//                     )}
//                 </td>
//             </tr>

//             {expanded &&
//                 node.children.map((child) => (
//                     <ProgrammeRow
//                         key={child._id}
//                         node={child}
//                         level={level + 1}
//                         setNotification={setNotification}
//                         openConfirm={openConfirm}
//                     />
//                 ))}
//         </>
//     );
// };

// /* =====================================================
//    Programme Segment Page
// ===================================================== */
// const ProgrammeSegment = () => {
//     const [treeData, setTreeData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [exporting, setExporting] = useState(false);
//     const [notification, setNotification] = useState({ show: false, message: "", type: "info" });
//     const [confirmState, setConfirmState] = useState({ open: false, token: "", nodeId: null, payload: null });

//     const [uploading, setUploading] = useState(false);
//     const [dragging, setDragging] = useState(false);
//     const [file, setFile] = useState(null);
//     const [previewData, setPreviewData] = useState([]);

//     // ✅ Scope
//     const [scope, setScope] = useState("state");

//     const [filters, setFilters] = useState({ code: "", level: "", isActive: "" });

//     const resetConfirm = () =>
//         setConfirmState({ open: false, token: "", nodeId: null, payload: null });

//     const handleCloseNotification = () =>
//         setNotification((prev) => ({ ...prev, show: false }));

//     /* ============================
//        CONFIRM UPDATE
//     ============================ */
//     const handleConfirm = async (input) => {
//         if (input !== confirmState.token) {
//             setNotification({ show: true, message: "Incorrect confirmation code", type: "error" });
//             return;
//         }

//         try {
//             await privateApi.patch(`/api/programme-segments/${confirmState.nodeId}`, confirmState.payload);
//             setNotification({ show: true, message: "Programme updated successfully", type: "success" });
//             fetchTree();
//             resetConfirm();
//         } catch (err) {
//             console.error(err);
//             setNotification({ show: true, message: "Update failed", type: "error" });
//         }
//     };

//     /* ============================
//        FETCH TREE
//     ============================ */
//     const fetchTree = async () => {
//         try {
//             setLoading(true);
//             const params = { ...filters, scope };
//             const queryParams = new URLSearchParams(params).toString();

//             const res = await privateApi.get(`/api/programme-segments?${queryParams}`);
//             setTreeData(res?.data?.data || []);
//         } catch (err) {
//             console.error(err);
//             setNotification({ show: true, message: "Failed to load data", type: "error" });
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         const initialFetchTree = async () => {
//             try {
//                 setLoading(true);
//                 const params = { ...filters, scope };
//                 const queryParams = new URLSearchParams(params).toString();

//                 const res = await privateApi.get(`/api/programme-segments?${queryParams}`);
//                 setTreeData(res?.data?.data || []);
//             } catch (err) {
//                 console.error(err);
//                 setNotification({ show: true, message: "Failed to load data", type: "error" });
//             } finally {
//                 setLoading(false);
//             }
//         };

//         initialFetchTree();
//     }, [filters, scope]);

//     /* ============================
//        FILE PROCESSING
//     ============================ */
//     const processFile = (file) => {
//         if (!file) return;

//         setFile(file);

//         const reader = new FileReader();
//         reader.onload = (e) => {
//             const data = new Uint8Array(e.target.result);
//             const workbook = XLSX.read(data, { type: "array" });
//             const sheet = workbook.Sheets[workbook.SheetNames[0]];
//             const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

//             const normalized = json.map((item) => ({
//                 code: String(item.CODE || "").trim(),
//                 description: String(item.DESCRIPTION || "").trim(),
//                 content: String(item.CONTENT || "").trim(),
//                 remark: String(item.REMARK || "").trim(),
//             }));

//             setPreviewData(normalized.slice(0, 10));
//         };

//         reader.readAsArrayBuffer(file);
//     };

//     const handleDrop = (e) => {
//         e.preventDefault();
//         setDragging(false);
//         processFile(e.dataTransfer.files[0]);
//     };

//     const handleDragOver = (e) => {
//         e.preventDefault();
//         setDragging(true);
//     };

//     const handleDragLeave = () => setDragging(false);

//     const handleFileChange = (e) => processFile(e.target.files[0]);

//     const handleUpload = async () => {
//         if (!file) {
//             setNotification({ show: true, message: "Select or drop a file first", type: "error" });
//             return;
//         }

//         try {
//             setUploading(true);

//             const formData = new FormData();
//             formData.append("file", file);
//             formData.append("scope", scope);

//             const res = await privateApi.post(`/api/programme-segments/upload-${scope}`, formData, {
//                 headers: { "Content-Type": "multipart/form-data" },
//                 timeout: 0,
//             });

//             setNotification({
//                 show: true,
//                 message: `Uploaded ${res.data.count} records successfully`,
//                 type: "success",
//             });

//             setFile(null);
//             setPreviewData([]);
//             fetchTree();
//         } catch (err) {
//             console.error(err);
//             setNotification({ show: true, message: "Upload error", type: "error" });
//         } finally {
//             setUploading(false);
//         }
//     };

//     /* ============================
//        EXPORT
//     ============================ */
//     const handleExport = async () => {
//         try {
//             setExporting(true);

//             const params = { ...filters, scope };
//             const queryParams = new URLSearchParams(params).toString();

//             const response = await privateApi.get(`/api/programme-segments/export?${queryParams}`, {
//                 responseType: "blob",
//             });

//             const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
//             const link = document.createElement("a");

//             link.href = URL.createObjectURL(blob);
//             link.download = "ProgrammeSegments.csv";
//             link.click();
//         } catch (err) {
//             console.error(err);
//             setNotification({ show: true, message: "Export failed", type: "error" });
//         } finally {
//             setExporting(false);
//         }
//     };

//     const handleFilterChange = (e) =>
//         setFilters({ ...filters, [e.target.name]: e.target.value });

//     return (
//         <div className="programme-container">
//             <Notification {...notification} onClose={handleCloseNotification} />

//             <header className="programme-segment-header">
//                 <h2>Programme Segments</h2>
//                 <div className="programme-segment-actions">
//                     <select value={scope} onChange={(e) => setScope(e.target.value)}>
//                         <option value="state">State</option>
//                         <option value="lga">LGA</option>
//                     </select>

//                     <Link className="programme-segment-add-link" to={"/programme-segments/create"}>Add Segment</Link>

//                     <button className="programme-segment-export-btn" onClick={handleExport} disabled={exporting}>
//                         {exporting ? "Exporting..." : "Export CSV"}
//                     </button>
//                 </div>
//             </header>

//             {/* Filters */}
//             <div className="programme-filters">
//                 <input type="text" name="code" placeholder="Filter by Code" value={filters.code} onChange={handleFilterChange} />

//                 <select name="level" value={filters.level} onChange={handleFilterChange}>
//                     <option value="">All Levels</option>
//                     {[1, 2, 3, 4].map((lvl) => (
//                         <option key={lvl} value={lvl}>Level {lvl}</option>
//                     ))}
//                 </select>

//                 <select name="isActive" value={filters.isActive} onChange={handleFilterChange}>
//                     <option value="">All Status</option>
//                     <option value="true">Active</option>
//                     <option value="false">Inactive</option>
//                 </select>
//             </div>

//             {/* Upload */}
//             <div
//                 className={`upload-dropzone ${dragging ? "dragging" : ""}`}
//                 onDrop={handleDrop}
//                 onDragOver={handleDragOver}
//                 onDragLeave={handleDragLeave}
//             >
//                 <p>Drag & drop Excel file or click</p>
//                 <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
//             </div>

//             <button className="programme-segment-upload-btn" onClick={handleUpload} disabled={uploading}>
//                 {uploading ? "Uploading..." : "Upload"}
//             </button>

//             {/* Preview */}
//             {previewData.length > 0 && (
//                 <div className="preview-table">
//                     <h4>Preview (First 10 rows)</h4>
//                     <table>
//                         <thead>
//                             <tr>
//                                 <th>Code</th>
//                                 <th>Description</th>
//                                 <th>Content</th>
//                                 <th>Remark</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {previewData.map((row, i) => (
//                                 <tr key={i}>
//                                     <td>{row.code}</td>
//                                     <td>{row.description}</td>
//                                     <td>{row.content}</td>
//                                     <td>{row.remark}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             )}

//             {/* Table */}
//             <div className="programme-table-wrapper">
//                 {loading ? (
//                     <Spinner loadingInfo="Loading Programme Segments..." />
//                 ) : (
//                     <table>
//                         <thead>
//                             <tr>
//                                 <th>Code</th>
//                                 <th>Description</th>
//                                 <th>Content</th>
//                                 <th>Remark</th>
//                                 <th>Status</th>
//                                 <th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {treeData.map((node) => (
//                                 <ProgrammeRow
//                                     key={node._id}
//                                     node={node}
//                                     setNotification={setNotification}
//                                     openConfirm={setConfirmState}
//                                 />
//                             ))}
//                         </tbody>
//                     </table>
//                 )}
//             </div>

//             {/* Confirm Dialog */}
//             {confirmState.open && (
//                 <ConfirmDialog
//                     show={confirmState.open}
//                     token={confirmState.token}
//                     action="You are about to update this programme segment"
//                     onConfirm={handleConfirm}
//                     onCancel={resetConfirm}
//                 />
//             )}
//         </div>
//     );
// };

// export default ProgrammeSegment;

import React, { useState, useEffect } from "react";
import privateApi from "../../apis/privateApi";
import Notification from "../../components/Notification/Notification";
// import Spinner from "../../components/Spinner/Spinner";
import * as XLSX from "xlsx";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";
import { Link } from "react-router-dom";
import { FiPlus, FiMinus } from "react-icons/fi";
import "./ProgrammeSegment.css";

/* ─── ProgrammeRow ───────────────────────────────────────────── */
const ProgrammeRow = ({ node, level = 1, setNotification, openConfirm }) => {
    const [expanded, setExpanded] = useState(false);
    const [editing, setEditing] = useState(false);
    const [description, setDescription] = useState(node.description || "");
    const [content, setContent] = useState(node.content || "");
    const [remark, setRemark] = useState(node.remark || "");

    const hasChildren = node.children?.length > 0;

    const handleSaveClick = () => {
        if (description.length > 100 || remark.length > 100) {
            setNotification({ show: true, message: "Description and Remark must not exceed 100 characters", type: "error" });
            return;
        }
        const token = Math.random().toString(36).substring(2, 8).toUpperCase();
        openConfirm({ open: true, token, nodeId: node._id, payload: { description, content, remark } });
    };

    return (
        <>
            <tr className={`seg-row-${Math.min(level, 4)}`}>
                <td style={{ paddingLeft: `${(level - 1) * 22 + 16}px` }}>
                    <div className="seg-code-cell">
                        {hasChildren && (
                            <button className="seg-toggle-btn" onClick={() => setExpanded(p => !p)}>
                                {expanded ? <FiMinus size={9} /> : <FiPlus size={9} />}
                            </button>
                        )}
                        <span className="seg-code-text">{node.code}</span>
                    </div>
                </td>
                <td>
                    {editing
                        ? <input className="seg-edit-input" value={description} onChange={e => setDescription(e.target.value)} />
                        : <span>{node.description || <span style={{ color: "var(--muted-light)" }}>—</span>}</span>}
                </td>
                <td className="prog-content-cell">
                    {editing
                        ? <input className="seg-edit-input" value={content} onChange={e => setContent(e.target.value)} />
                        : node.content || <span style={{ color: "var(--muted-light)" }}>—</span>}
                </td>
                <td>
                    {editing
                        ? <input className="seg-edit-input" value={remark} onChange={e => setRemark(e.target.value)} />
                        : <span style={{ color: "var(--muted)" }}>{node.remark || <span style={{ color: "var(--muted-light)" }}>—</span>}</span>}
                </td>
                <td>
                    <span className={`seg-status ${node.isActive ? "active" : "inactive"}`}>
                        <span className="seg-status-dot" />
                        {node.isActive ? "Active" : "Inactive"}
                    </span>
                </td>
                <td>
                    <div className="seg-action-wrap">
                        {!editing
                            ? <button className="seg-icon-btn" title="Edit" onClick={() => setEditing(true)}>✏️</button>
                            : <>
                                <button className="seg-icon-btn save" title="Save" onClick={handleSaveClick}>💾</button>
                                <button className="seg-icon-btn cancel" title="Cancel" onClick={() => setEditing(false)}>✕</button>
                            </>
                        }
                    </div>
                </td>
            </tr>
            {expanded && node.children.map(child => (
                <ProgrammeRow key={child._id} node={child} level={level + 1}
                    setNotification={setNotification} openConfirm={openConfirm} />
            ))}
        </>
    );
};

/* ─── Page ───────────────────────────────────────────────────── */
const ProgrammeSegment = () => {
    const [treeData, setTreeData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [exporting, setExporting] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [dragging, setDragging] = useState(false);
    const [file, setFile] = useState(null);
    const [previewData, setPreviewData] = useState([]);
    const [scope, setScope] = useState("state");
    const [filters, setFilters] = useState({ code: "", level: "", isActive: "" });
    const [notification, setNotification] = useState({ show: false, message: "", type: "info" });
    const [confirmState, setConfirmState] = useState({ open: false, token: "", nodeId: null, payload: null });

    const resetConfirm = () => setConfirmState({ open: false, token: "", nodeId: null, payload: null });

    const fetchTree = async () => {
        try {
            setLoading(true);
            const res = await privateApi.get(`/api/programme-segments?${new URLSearchParams({ ...filters, scope })}`);
            setTreeData(res?.data?.data || []);
        } catch { setNotification({ show: true, message: "Failed to load data", type: "error" }); }
        finally { setLoading(false); }
    };

    useEffect(() => {
        const initialFetchTree = async () => {
            try {
                setLoading(true);
                const res = await privateApi.get(`/api/programme-segments?${new URLSearchParams({ ...filters, scope })}`);
                setTreeData(res?.data?.data || []);
            } catch { setNotification({ show: true, message: "Failed to load data", type: "error" }); }
            finally { setLoading(false); }
        };

        initialFetchTree();
    }, [filters, scope]);

    const handleConfirm = async input => {
        if (input !== confirmState.token) {
            setNotification({ show: true, message: "Incorrect confirmation code", type: "error" }); return;
        }
        try {
            await privateApi.patch(`/api/programme-segments/${confirmState.nodeId}`, confirmState.payload);
            setNotification({ show: true, message: "Programme updated successfully", type: "success" });
            fetchTree(); resetConfirm();
        } catch { setNotification({ show: true, message: "Update failed", type: "error" }); }
    };

    const processFile = f => {
        if (!f) return;
        setFile(f);
        const reader = new FileReader();
        reader.onload = e => {
            const wb = XLSX.read(new Uint8Array(e.target.result), { type: "array" });
            const json = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { defval: "" });
            setPreviewData(json.map(item => ({
                code: String(item.CODE || "").trim(),
                description: String(item.DESCRIPTION || "").trim(),
                content: String(item.CONTENT || "").trim(),
                remark: String(item.REMARK || "").trim(),
            })).slice(0, 10));
        };
        reader.readAsArrayBuffer(f);
    };

    const handleUpload = async () => {
        if (!file) return setNotification({ show: true, message: "Select or drop a file first", type: "error" });
        try {
            setUploading(true);
            const fd = new FormData(); fd.append("file", file); fd.append("scope", scope);
            const res = await privateApi.post(`/api/programme-segments/upload-${scope}`, fd, {
                headers: { "Content-Type": "multipart/form-data" }, timeout: 0,
            });
            setNotification({ show: true, message: `Uploaded ${res.data.count} records successfully`, type: "success" });
            setFile(null); setPreviewData([]); fetchTree();
        } catch { setNotification({ show: true, message: "Upload error", type: "error" }); }
        finally { setUploading(false); }
    };

    const handleExport = async () => {
        try {
            setExporting(true);
            const res = await privateApi.get(
                `/api/programme-segments/export?${new URLSearchParams({ ...filters, scope })}`,
                { responseType: "blob" }
            );
            const link = document.createElement("a");
            link.href = URL.createObjectURL(new Blob([res.data], { type: "text/csv;charset=utf-8;" }));
            link.download = "ProgrammeSegments.csv"; link.click();
        } catch { setNotification({ show: true, message: "Export failed", type: "error" }); }
        finally { setExporting(false); }
    };

    return (
        <div className="seg-page">
            <Notification show={notification.show} message={notification.message}
                type={notification.type} onClose={() => setNotification(p => ({ ...p, show: false }))} />

            <div className="seg-header">
                <div className="seg-header-left">
                    <h1>Programme Segments</h1>
                    <p>Manage the programme classification hierarchy for budget lines</p>
                </div>
                <div className="seg-header-actions">
                    <select className="seg-scope-select" value={scope} onChange={e => setScope(e.target.value)}>
                        <option value="state">State</option>
                        <option value="lga">LGA</option>
                    </select>
                    <Link className="seg-btn seg-btn-primary" to="/programme-segments/create">+ Add Segment</Link>
                    <button className="seg-btn seg-btn-muted" onClick={handleExport} disabled={exporting}>
                        {exporting ? "Exporting…" : "⬇ Export CSV"}
                    </button>
                </div>
            </div>

            <div className="seg-filter-bar">
                <span className="seg-filter-label">Filter</span>
                <input className="seg-filter-input" placeholder="Search by code…"
                    value={filters.code} onChange={e => setFilters(p => ({ ...p, code: e.target.value }))} />
                <select className="seg-filter-select" value={filters.level}
                    onChange={e => setFilters(p => ({ ...p, level: e.target.value }))}>
                    <option value="">All Levels</option>
                    {[1, 2, 3, 4].map(l => <option key={l} value={l}>Level {l}</option>)}
                </select>
                <select className="seg-filter-select" value={filters.isActive}
                    onChange={e => setFilters(p => ({ ...p, isActive: e.target.value }))}>
                    <option value="">All Status</option>
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                </select>
            </div>

            <div className="seg-upload-section">
                <div className={`seg-dropzone ${dragging ? "dragging" : ""}`}
                    onDrop={e => { e.preventDefault(); setDragging(false); processFile(e.dataTransfer.files[0]); }}
                    onDragOver={e => { e.preventDefault(); setDragging(true); }}
                    onDragLeave={() => setDragging(false)}>
                    <span className="seg-dropzone-icon">📂</span>
                    <p>Drag &amp; drop Excel file here</p>
                    <span>or click to browse (.xlsx, .xls)</span>
                    {file && <div className="seg-file-name">📄 {file.name}</div>}
                    <input type="file" accept=".xlsx,.xls" onChange={e => processFile(e.target.files[0])} />
                </div>
                <div className="seg-upload-actions">
                    <button className="seg-btn seg-btn-primary" onClick={handleUpload} disabled={uploading || !file}>
                        {uploading ? "Uploading…" : "⬆ Upload"}
                    </button>
                </div>
            </div>

            {previewData.length > 0 && (
                <div className="seg-preview">
                    <div className="seg-preview-title">Preview <span className="seg-preview-badge">First 10 rows</span></div>
                    <div className="seg-table-scroll">
                        <table className="seg-shared-table">
                            <thead><tr><th>Code</th><th>Description</th><th>Content</th><th>Remark</th></tr></thead>
                            <tbody>
                                {previewData.map((row, i) => (
                                    <tr key={i}><td>{row.code}</td><td>{row.description}</td><td>{row.content}</td><td>{row.remark}</td></tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            <div className="seg-table-card">
                {loading ? (
                    <div className="seg-loading-wrap"><div className="seg-spinner" /><p className="seg-loading-text">Loading Programme Segments…</p></div>
                ) : (
                    <div className="seg-table-scroll">
                        <table className="seg-table">
                            <thead>
                                <tr><th>Code</th><th>Description</th><th>Content</th><th>Remark</th><th>Status</th><th>Actions</th></tr>
                            </thead>
                            <tbody>
                                {treeData.map(node => (
                                    <ProgrammeRow key={node._id} node={node}
                                        setNotification={setNotification} openConfirm={setConfirmState} />
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {confirmState.open && (
                <ConfirmDialog show={confirmState.open} token={confirmState.token}
                    action="You are about to update this programme segment"
                    onConfirm={handleConfirm} onCancel={resetConfirm} />
            )}
        </div>
    );
};

export default ProgrammeSegment;